import { JsonObject, JsonProperty } from 'json2typescript';
import { Entity } from './entity';

@JsonObject('SalesOrderDocumentsFilter')
export class SalesOrderDocumentsFilter extends Entity {
  @JsonProperty('serialNumbers', [String])
  public serialNumbers: string[] = [];
  @JsonProperty('orderBy', [String])
  public orderBy: string[] = [];
  @JsonProperty('direction', [String])
  public direction: string[] = [];
}
